"use strict";

var React = require("react"),
    _extendStatics = function extendStatics(e, t) {
  return (_extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (e, t) {
    e.__proto__ = t;
  } || function (e, t) {
    for (var o in t) {
      t.hasOwnProperty(o) && (e[o] = t[o]);
    }
  })(e, t);
};

function __extends(e, t) {
  function o() {
    this.constructor = e;
  }

  _extendStatics(e, t), e.prototype = null === t ? Object.create(t) : (o.prototype = t.prototype, new o());
}

var _assign = function __assign() {
  return (_assign = Object.assign || function (e) {
    for (var t, o = 1, n = arguments.length; o < n; o++) {
      for (var r in t = arguments[o]) {
        Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
      }
    }

    return e;
  }).apply(this, arguments);
};

function isObject(e) {
  var t = typeof e;
  return null != e && ("object" == t || "function" == t);
}

var isObject_1 = isObject,
    commonjsGlobal = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {},
    freeGlobal = "object" == typeof commonjsGlobal && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal,
    _freeGlobal = freeGlobal,
    freeSelf = "object" == typeof self && self && self.Object === Object && self,
    root = _freeGlobal || freeSelf || Function("return this")(),
    _root = root,
    now = function now() {
  return _root.Date.now();
},
    now_1 = now,
    Symbol = _root.Symbol,
    _Symbol = Symbol,
    objectProto = Object.prototype,
    hasOwnProperty = objectProto.hasOwnProperty,
    nativeObjectToString = objectProto.toString,
    symToStringTag = _Symbol ? _Symbol.toStringTag : void 0;

function getRawTag(e) {
  var t = hasOwnProperty.call(e, symToStringTag),
      o = e[symToStringTag];

  try {
    var n = !(e[symToStringTag] = void 0);
  } catch (e) {}

  var r = nativeObjectToString.call(e);
  return n && (t ? e[symToStringTag] = o : delete e[symToStringTag]), r;
}

var _getRawTag = getRawTag,
    objectProto$1 = Object.prototype,
    nativeObjectToString$1 = objectProto$1.toString;

function objectToString(e) {
  return nativeObjectToString$1.call(e);
}

var _objectToString = objectToString,
    nullTag = "[object Null]",
    undefinedTag = "[object Undefined]",
    symToStringTag$1 = _Symbol ? _Symbol.toStringTag : void 0;

function baseGetTag(e) {
  return null == e ? void 0 === e ? undefinedTag : nullTag : symToStringTag$1 && symToStringTag$1 in Object(e) ? _getRawTag(e) : _objectToString(e);
}

var _baseGetTag = baseGetTag;

function isObjectLike(e) {
  return null != e && "object" == typeof e;
}

var isObjectLike_1 = isObjectLike,
    symbolTag = "[object Symbol]";

function isSymbol(e) {
  return "symbol" == typeof e || isObjectLike_1(e) && _baseGetTag(e) == symbolTag;
}

var isSymbol_1 = isSymbol,
    NAN = NaN,
    reTrim = /^\s+|\s+$/g,
    reIsBadHex = /^[-+]0x[0-9a-f]+$/i,
    reIsBinary = /^0b[01]+$/i,
    reIsOctal = /^0o[0-7]+$/i,
    freeParseInt = parseInt;

function toNumber(e) {
  if ("number" == typeof e) return e;
  if (isSymbol_1(e)) return NAN;

  if (isObject_1(e)) {
    var t = "function" == typeof e.valueOf ? e.valueOf() : e;
    e = isObject_1(t) ? t + "" : t;
  }

  if ("string" != typeof e) return 0 === e ? e : +e;
  e = e.replace(reTrim, "");
  var o = reIsBinary.test(e);
  return o || reIsOctal.test(e) ? freeParseInt(e.slice(2), o ? 2 : 8) : reIsBadHex.test(e) ? NAN : +e;
}

var toNumber_1 = toNumber,
    FUNC_ERROR_TEXT = "Expected a function",
    nativeMax = Math.max,
    nativeMin = Math.min;

function debounce(n, o, e) {
  var r,
      i,
      a,
      s,
      l,
      c,
      u = 0,
      f = !1,
      d = !1,
      t = !0;
  if ("function" != typeof n) throw new TypeError(FUNC_ERROR_TEXT);

  function p(e) {
    var t = r,
        o = i;
    return r = i = void 0, u = e, s = n.apply(o, t);
  }

  function g(e) {
    var t = e - c;
    return void 0 === c || o <= t || t < 0 || d && a <= e - u;
  }

  function h() {
    var e = now_1();
    if (g(e)) return v(e);
    l = setTimeout(h, function (e) {
      var t = o - (e - c);
      return d ? nativeMin(t, a - (e - u)) : t;
    }(e));
  }

  function v(e) {
    return l = void 0, t && r ? p(e) : (r = i = void 0, s);
  }

  function b() {
    var e = now_1(),
        t = g(e);

    if (r = arguments, i = this, c = e, t) {
      if (void 0 === l) return function (e) {
        return u = e, l = setTimeout(h, o), f ? p(e) : s;
      }(c);
      if (d) return clearTimeout(l), l = setTimeout(h, o), p(c);
    }

    return void 0 === l && (l = setTimeout(h, o)), s;
  }

  return o = toNumber_1(o) || 0, isObject_1(e) && (f = !!e.leading, a = (d = "maxWait" in e) ? nativeMax(toNumber_1(e.maxWait) || 0, o) : a, t = "trailing" in e ? !!e.trailing : t), b.cancel = function () {
    void 0 !== l && clearTimeout(l), r = c = i = l = void (u = 0);
  }, b.flush = function () {
    return void 0 === l ? s : v(now_1());
  }, b;
}

var debounce_1 = debounce,
    isWindow = "undefined" != typeof window,
    rootStyle = {
  position: "relative",
  overflow: "hidden"
},
    wrapStyle = {
  display: "flex",
  alignItems: "center",
  position: "relative",
  zIndex: 0,
  height: "100%",
  whiteSpace: "nowrap"
},
    arrowWrapStyle = {
  position: "absolute",
  zIndex: 1,
  top: 0,
  height: "100%",
  cursor: "pointer",
  outline: 0
},
    OverflowList = function (e) {
  function t() {
    var u = null !== e && e.apply(this, arguments) || this;
    return u.rootRef = React.createRef(), u.wrapRef = React.createRef(), u.state = {
      isOverflow: !1,
      rootWidth: 0,
      wrapWidth: 0,
      x: 0,
      isDragging: !1,
      mouseX: 0
    }, u.debouncedResize = debounce_1(function () {
      u.handleResize();
    }, 300), u.handleResize = function () {
      var e = u.state,
          t = e.isOverflow,
          o = e.x,
          n = u.rootRef.current ? u.rootRef.current.clientWidth : 0,
          r = u.wrapRef.current ? u.wrapRef.current.scrollWidth : 0;

      if (n <= r) {
        var i = {
          rootWidth: n,
          wrapWidth: r,
          isOverflow: !0
        };

        if (r < n + Math.abs(o)) {
          var a = Math.abs(r - n + o);
          i.x = o + a;
        }

        u.setState(i);
      } else t && u.setState({
        isOverflow: !1
      });
    }, u.handleWheel = function (e) {
      var t = u.state,
          o = t.isOverflow,
          n = t.rootWidth,
          r = t.wrapWidth,
          i = t.x;

      if (o) {
        var a = i;
        0 < e.deltaX ? n - r < i && (a -= 4) : i < 0 && (a += 4), u.setState({
          x: a
        });
      }
    }, u.handleMouseDown = function (e) {
      var t = u.state,
          o = t.isOverflow,
          n = t.x;

      if (o) {
        var r = 0;
        if ("mousedown" === e.type) r = e.pageX + -n;else if ("touchstart" === e.type) {
          r = e.changedTouches[0].pageX + -n;
        }
        u.setState({
          mouseX: r,
          isDragging: !0
        });
      }
    }, u.handleMouseMove = function (e) {
      var t = u.state,
          o = t.isOverflow,
          n = t.isDragging,
          r = t.rootWidth,
          i = t.wrapWidth,
          a = t.x,
          s = t.mouseX;

      if (o && n) {
        var l = 0;
        if ("mousemove" === e.type) e.preventDefault(), l = e.pageX - s;else if ("touchmove" === e.type) {
          l = e.changedTouches[0].pageX - s;
        }
        var c = .5 * (a + l);
        0 < c && (c = 0), i - r < -c && (c = -(i - r)), u.setState({
          x: c
        });
      }
    }, u.handleMouseUp = function () {
      var e = u.state,
          t = e.isOverflow,
          o = e.isDragging;
      t && o && u.setState({
        isDragging: !1
      });
    }, u.handleClickLeft = function (e) {
      e.stopPropagation(), e.preventDefault(), u.setState(function (e) {
        u.wrapRef.current && (u.wrapRef.current.style.transition = "transform 0.3s ease-in-out");
        var t = e.x + 100;
        return 0 < t && (t = 0), {
          x: t
        };
      }, function () {
        setTimeout(function () {
          u.wrapRef.current && (u.wrapRef.current.style.transition = "none");
        }, 300);
      });
    }, u.handleClickRight = function (e) {
      e.stopPropagation(), e.preventDefault();
      var t = u.state,
          o = t.rootWidth,
          n = t.wrapWidth;
      u.setState(function (e) {
        u.wrapRef.current && (u.wrapRef.current.style.transition = "transform 0.3s ease-in-out");
        var t = e.x - 100;
        return n - o < -t && (t = -(n - o)), {
          x: t
        };
      }, function () {
        setTimeout(function () {
          u.wrapRef.current && (u.wrapRef.current.style.transition = "none");
        }, 300);
      });
    }, u.renderLeftIcon = function () {
      var e = u.props,
          t = e.iconColor,
          o = e.iconSize,
          n = e.iconStyle,
          r = e.iconWrapStyle,
          i = e.leftIcon;
      return React.createElement("div", {
        className: "react-overflow-wrapper__icon-left",
        style: _assign(_assign(_assign({}, arrowWrapStyle), {
          left: 0,
          textAlign: "left"
        }), r.left),
        role: "button",
        tabIndex: 0,
        onClick: u.handleClickLeft,
        onKeyPress: function onKeyPress() {
          return null;
        }
      }, i || React.createElement("svg", {
        style: _assign({
          position: "relative"
        }, n.left),
        width: o,
        height: o,
        viewBox: "0 0 48 48"
      }, React.createElement("path", {
        d: "M30.83 32.67l-9.17-9.17 9.17-9.17L28 11.5l-12 12 12 12z",
        fill: t
      }), React.createElement("path", {
        d: "M0-.25h48v48H0z",
        fill: "none"
      })));
    }, u.renderRightIcon = function () {
      var e = u.props,
          t = e.iconColor,
          o = e.iconSize,
          n = e.iconStyle,
          r = e.iconWrapStyle,
          i = e.rightIcon;
      return React.createElement("div", {
        className: "react-overflow-wrapper__icon-right",
        style: _assign(_assign(_assign({}, arrowWrapStyle), {
          right: 0,
          textAlign: "right"
        }), r.right),
        role: "button",
        tabIndex: 0,
        onClick: u.handleClickRight,
        onKeyPress: function onKeyPress() {
          return null;
        }
      }, i || React.createElement("svg", {
        style: _assign({
          position: "relative"
        }, n.right),
        width: o,
        height: o,
        viewBox: "0 0 48 48"
      }, React.createElement("path", {
        d: "M17.17 32.92l9.17-9.17-9.17-9.17L20 11.75l12 12-12 12z",
        fill: t
      }), React.createElement("path", {
        d: "M0-.25h48v48H0z",
        fill: "none"
      })));
    }, u;
  }

  return __extends(t, e), t.prototype.componentDidMount = function () {
    this.handleResize(), isWindow && window.addEventListener("resize", this.debouncedResize);
  }, t.prototype.componentWillUnmount = function () {
    isWindow && window.removeEventListener("resize", this.debouncedResize);
  }, t.prototype.render = function () {
    var e = this.props,
        t = e.children,
        o = e.className,
        n = e.hideIcons,
        r = e.style,
        i = this.state,
        a = i.x,
        s = i.isOverflow,
        l = i.rootWidth,
        c = i.wrapWidth,
        u = this.renderLeftIcon,
        f = this.renderRightIcon;
    return React.createElement("div", {
      className: "react-overflow-wrapper " + (o || ""),
      ref: this.rootRef,
      style: _assign(_assign({}, rootStyle), r)
    }, React.createElement("div", {
      className: "react-overflow-wrapper__content",
      ref: this.wrapRef,
      style: _assign(_assign({}, wrapStyle), {
        transform: "translate3d(" + a + "px, 0, 0)"
      }),
      role: "presentation",
      onWheel: this.handleWheel,
      onMouseDown: this.handleMouseDown,
      onMouseMove: this.handleMouseMove,
      onMouseUp: this.handleMouseUp,
      onMouseLeave: this.handleMouseUp,
      onTouchStart: this.handleMouseDown,
      onTouchMove: this.handleMouseMove,
      onTouchEnd: this.handleMouseUp
    }, t), !n && s && a < 0 && React.createElement(u, null), !n && s && -a < c - l && React.createElement(f, null));
  }, t.defaultProps = {
    className: void 0,
    style: void 0,
    hideIcons: !1,
    leftIcon: void 0,
    rightIcon: void 0,
    iconSize: 26,
    iconColor: "#aeb6bb",
    iconWrapStyle: {
      left: {
        backgroundImage: "linear-gradient(to right, hsl(0, 100%, 100%) 25%, hsla(0, 0%, 0%, 0))"
      },
      right: {
        backgroundImage: "linear-gradient(to left, hsl(0, 100%, 100%) 25%, hsla(0, 0%, 0%, 0))"
      }
    },
    iconStyle: {
      left: {},
      right: {}
    }
  }, t;
}(React.Component);

module.exports = OverflowList;